// export const API_PORT = '4000'
export const API_URL = 'https://whitesidetimes.com/api'
export const DOMAIN_TITLE = 'whitesidetimes.com'




// WEBPACK FOOTER //
// ./src/.env.js